import { render, staticRenderFns } from "./TacticDetail.vue?vue&type=template&id=552c262f"
import script from "./TacticDetail.vue?vue&type=script&lang=ts"
export * from "./TacticDetail.vue?vue&type=script&lang=ts"
import style0 from "./TacticDetail.vue?vue&type=style&index=0&id=552c262f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports